import * as React from "react";
export const VisibilityContext = React.createContext(true);
